"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "candelo": {
    "6cffc5f8": [{
      "hkey": "8f13e702",
      "slug": "candelo",
      "name": "Candelo",
      "primary": true,
      "skipSearch": false
    }],
    "candelo-centro-la-villa": [{
      "hkey": "8f13e702",
      "slug": "candelo",
      "name": "Candelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "524b6b33": [{
      "hkey": "8f13e702",
      "slug": "candelo",
      "name": "Candelo",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo-porcignano": [{
      "hkey": "8f13e702",
      "slug": "candelo",
      "name": "Candelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d1a6b63": [{
      "hkey": "8f13e702",
      "slug": "candelo",
      "name": "Candelo",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo-arbengo": [{
      "hkey": "8f13e702",
      "slug": "candelo",
      "name": "Candelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;